import { TransactionDetailContent } from '@/app/payment-transactions/[id]/TransactionDetailContent';

export function CardVaultTransactionDetailContent() {
    return <TransactionDetailContent mode="card-vault" />;
}
